module.exports = __webpack_public_path__ + "static/img/sitename.30d85f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sitename.png
// module id = aeaw
// module chunks = 1